
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electronic-consent",
      function () {
        return require("private-next-pages/electronic-consent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electronic-consent"])
      });
    }
  